import { render, staticRenderFns } from "./Publicy.vue?vue&type=template&id=4175f95b&scoped=true&"
import script from "./Publicy.vue?vue&type=script&lang=ts&"
export * from "./Publicy.vue?vue&type=script&lang=ts&"
import style0 from "./Publicy.vue?vue&type=style&index=0&id=4175f95b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4175f95b",
  null
  
)

export default component.exports